/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useEffect } from 'react';

// Material UI
import { Tooltip, IconButton } from '@material-ui/core';

// Material UI Icons
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';

// React To Print
import ReactToPrint from 'react-to-print';

export interface StateProps {
  title: string;
  elementRef: any;
  setIsPrinting?: (element: boolean) => void;
  isPrinting?: boolean;
}

type Props = StateProps;

export const pageStyle = `
  @media print {
    @media all {
      .page-break {
        display: none;
      }
    }
  @media print {
    html, body {
      zoom: 70%;
      height: 100% !important;
      width: 100% !important;
      overflow: visible !important;
      -webkit-print-color-adjust: exact;
    }
  }
`;

const ExportToPdf: React.FC<Props> = ({
  title,
  elementRef,
  setIsPrinting,
  isPrinting,
}) => {
  useEffect(() => {
    if (isPrinting) {
      // @ts-ignore
      document.getElementById('prit-pdf').click();
    }
  }, [isPrinting]);
  return (
    <ReactToPrint
      pageStyle={pageStyle}
      onBeforeGetContent={() => {
        if (setIsPrinting) setIsPrinting(true);
      }}
      trigger={() => (
        <Tooltip title='Exportar como PDF' placement='left' arrow>
          <IconButton id='prit-pdf'>
            <PictureAsPdf />
          </IconButton>
        </Tooltip>
      )}
      documentTitle={title}
      // eslint-disable-next-line
      content={() => elementRef}
      onAfterPrint={() => {
        document.body.style.zoom = '100%';
        if (setIsPrinting) setIsPrinting(false);
      }}
    />
  );
};

export default ExportToPdf;
export { ExportToPdf };
